// extracted by mini-css-extract-plugin
export default {"slot":"webpack-pages-StudyList-StudyListItem-LibkeyLink-module__slot"};